import { useQuery, useMutation, useQueryClient } from 'react-query'
import client from './api-client'

async function signUp({
	name,
	lastName,
	email,
	password,
	profession,
	professionSpecification,
	company,
	terms_and_policy,
	marketing_consent,
	confirm_invitation,
	language,
	captcha,
	promo_code,
	sign_up_event,
	campaign,
	origin,
}) {
	const data = await client(`sign_up/`, {
		body: {
			name: name,
			last_name: lastName ?? '',
			email: email,
			password: password,
			profession: profession,
			professionSpecification: professionSpecification,
			company: company,
			terms_and_policy: terms_and_policy,
			// Optional, opt-in only: newsletter, product news, promotions and webinars.
			marketing_consent: marketing_consent ?? false,
			confirm_invitation: confirm_invitation ?? false,
			language: language,
			captcha: captcha,
			promo_code: promo_code,
			sign_up_event: sign_up_event,
			campaign: campaign,
			origin: origin,
		},
	})
	return data
}

export function useSignUpMutation() {
	const queryClient = useQueryClient()

	return useMutation((payload) => signUp(payload), {
		onSuccess: (data, variables) => {
			queryClient.invalidateQueries(['sign_up_data', data])
		},
	})
}

async function confirmSignUp([company]) {
	const data = await client(`confirm_signup/`, {
		body: { company: company },
	})
	return data
}

export function useConfirmSignUpMutation() {
	const queryClient = useQueryClient()

	return useMutation((company) => confirmSignUp(company), {
		onSuccess: (data, variables) => {
			queryClient.invalidateQueries(['confirm_sign_up_data', data])
		},
	})
}
